module.exports = __webpack_public_path__ + "img/dashboard-icon7.4195137a.svg";